import {
  AvatarGroup as MuiAvatarGroup,
  AvatarGroupProps as MuiAvatarGroupProps,
} from '@mui/material';

export const AvatarGroup = MuiAvatarGroup;
export type AvatarGroupProps = MuiAvatarGroupProps;
